<div class="info-block">
  <h3 class="info-title">
    {{ 'account_customer_info.contacts' | translate }}
  </h3>

  <div class="info-content">
    @if (formVisibility() === 'contact') {
      <contact-info
        [contactInfo]="customer.contactInfo"
        [inputList]="['names']"
        (formSubmitted)="saveContactInfo()"
      ></contact-info>

      @if (httpError()) {
        <div class="form__error">
          {{ httpError() }}
        </div>
      }

      <div class="info-save-buttons">
        <tc-button
          class="info-save-button"
          (click)="saveContactInfo()"
          [isLoading]="isLoading()"
          [isSmall]="true"
          [isDisabled]="isLoading()"
          buttonType="submit"
        >
          {{ 'global.save' | translate }}
        </tc-button>

        <tc-button
          class="info-save-button"
          (click)="setFormVisibility(null)"
          [isSmall]="true"
          [isStyleDefault]="true"
          [isDisabled]="isLoading()"
        >
          {{ 'global.cancel' | translate }}
        </tc-button>
      </div>

    } @else {
      <div class="info-row">
        @if (customer.contactInfo.lastName || customer.contactInfo.firstName || customer.contactInfo.middleName) {
          {{ customer.contactInfo.lastName }} {{ customer.contactInfo.firstName }} {{ customer.contactInfo.middleName }}
        } @else {
          ---
        }
      </div>

      <tc-button
        class="info-edit-btn"
        (click)="setFormVisibility('contact')"
        [isDisabled]="isEditBtnDisabled()"
        [isSmall]="true"
        [isStyleDefault]="true"
      >
        {{ 'account_customer_info.edit' | translate }}
      </tc-button>
    }
  </div>
</div>

<div class="info-block">
  <h3 class="info-title">
    {{ 'account_customer_info.phone_number' | translate }}
  </h3>

  <div class="info-content">
    @if (formVisibility() === 'phone') {
      <contact-info
        [contactInfo]="customer.contactInfo"
        [inputList]="['phone']"
        (formSubmitted)="savePhoneNumber()"
      ></contact-info>

      @if (httpError()) {
        <div class="form__error">
          {{ httpError() }}
        </div>
      }

      <div class="info-save-buttons">
        <tc-button
          class="info-save-button"
          (click)="savePhoneNumber()"
          [isLoading]="isLoading()"
          [isSmall]="true"
          [isDisabled]="isLoading()"
          buttonType="submit"
        >
          {{ 'global.save' | translate }}
        </tc-button>

        <tc-button
          class="info-save-button"
          (click)="setFormVisibility(null)"
          [isSmall]="true"
          [isStyleDefault]="true"
          [isDisabled]="isLoading()"
        >
          {{ 'global.cancel' | translate }}
        </tc-button>
      </div>

    } @else {
      <div class="info-row">
        {{ (customer.contactInfo.phoneNumber | mask: PHONE_NUMBER_MASK) || '---' }}
      </div>

      <tc-button
        class="info-edit-btn"
        (click)="setFormVisibility('phone')"
        [isDisabled]="isEditBtnDisabled()"
        [isSmall]="true"
        [isStyleDefault]="true"
      >
        {{ 'account_customer_info.edit' | translate }}
      </tc-button>
    }
  </div>
</div>

<div class="info-block">
  <h3 class="info-title">
    {{ 'global.email' | translate }}
  </h3>

  <div class="info-content">
    @if (formVisibility() === 'email') {
      <div
        class="form__control-container info-control"
        [class.field--invalid]="isControlInvalid(emailControl)"
      >
        <label
          class="form__label"
          for="email"
        >
          {{ 'account_customer_info.new_email' | translate }}
        </label>

        <div class="form__control">
          <input
            class="form__input"
            [formControl]="emailControl"
            type="text"
            id="email"
            (keydown.enter)="saveEmail()"
          >

          @if (isControlInvalid(emailControl)) {
            <div class="form__input-error">
              {{ 'global.required_field' | translate }}
            </div>
          }
        </div>
      </div>

      @if (httpError()) {
        <div class="form__error">
          {{ httpError() }}
        </div>
      }

      <div class="info-save-buttons">
        <tc-button
          class="info-save-button"
          (click)="saveEmail()"
          [isLoading]="isLoading()"
          [isDisabled]="isLoading()"
          [isSmall]="true"
        >
          {{ 'global.save' | translate }}
        </tc-button>

        <tc-button
          class="info-save-button"
          (click)="setFormVisibility(null)"
          [isSmall]="true"
          [isStyleDefault]="true"
          [isDisabled]="isLoading()"
        >
          {{ 'global.cancel' | translate }}
        </tc-button>
      </div>

    } @else {
      <div class="info-row">
        {{ customer.contactInfo.email || '---' }}
      </div>

      <tc-button
        class="info-edit-btn"
        (click)="setFormVisibility('email')"
        [isDisabled]="isEditBtnDisabled()"
        [isSmall]="true"
        [isStyleDefault]="true"
      >
        {{ 'account_customer_info.edit' | translate }}
      </tc-button>
    }
  </div>
</div>

<div class="info-block">
  <h3 class="info-title">
    {{ 'global.password' | translate }}
  </h3>

  <tc-button
    class="info-edit-btn"
    (click)="changePassword()"
    [isDisabled]="isEditBtnDisabled()"
    [isSmall]="true"
    [isStyleDefault]="true"
  >
    {{ 'global.change_password' | translate }}
  </tc-button>
</div>
